<div ng-show="showloading" class="loading-screen">
    <svg class="loading-animation" width="100" height="100">
      <circle class="colored" cx="50" cy="50" r="40"> </circle>
    </svg>
  <div class="loading-text">
    {{loadingText}}
  </div>
</div>
